import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import { SearchBar } from '../../../../components/SearchBar';
import Tree from './components/Tree';
import SmallListToppings from '../../../../components/SmallListToppings';
import { PlaceStoreContext } from '../../../../reducers/Place/PlaceContext';

const getToppingGroupsCache = (searching, index) => {
  const nameToppingGroups = [];
  const containsName = index.namesToppingsGroups.filter((toppingGroupName) =>
    toppingGroupName.includes(searching.trim().toLowerCase()),
  );

  for (const name of containsName) {
    nameToppingGroups.push(index.name__toppingGroup[name]);
  }

  return nameToppingGroups;
};

const getToppingsCache = (searching, index) => {
  const nameToppings = [];

  const containsName = index.namesToppings.filter((toppingName) =>
    toppingName.includes(searching.trim().toLowerCase()),
  );

  for (const name of containsName) {
    nameToppings.push(index.name__topping[name]);
  }

  return nameToppings;
};

const TabToppings = () => {
  const [placeState] = useContext(PlaceStoreContext);
  const [searching, setSearching] = useState('');
  const [searchedToppings, setSearchedToppings] = useState([]);
  const [searchedToppingGroups, setSearchedToppingGroups] = useState([]);

  const {
    toppings: { indexToppings },
  } = placeState;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (searching.length > 2) {
      const toppings = getToppingsCache(searching, indexToppings);
      toppings.length > 0 && setSearchedToppings(toppings);
      const toppingGroups = getToppingGroupsCache(searching, indexToppings);
      toppingGroups.length > 0 && setSearchedToppingGroups(toppingGroups);
    } else {
      searchedToppings.length > 0 && setSearchedToppings([]);
      searchedToppingGroups.length > 0 && setSearchedToppingGroups([]);
    }
  }, [searching, placeState]);

  return (
    <div style={{ margin: '40px 16px 0 16px' }}>
      <Grid container justify="center">
        <Grid item xs={12}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <SearchBar searching={searching} setSearching={setSearching} style={{ height: '36px' }} placeholder="Search in toppings ..."/>
          </div>
        </Grid>
        <Grid item xs={12} sm={8} md={6} style={{ marginLeft: '20px'}}>
          <SmallListToppings toppings={searchedToppings} toppingGroups={searchedToppingGroups} visible={searching.length > 2} />
        </Grid>
      </Grid>

      {!(searching.length > 2) && (
        <Grid container justify="center" style={{ justifyContent: 'center' }}>
          <Grid item xs={12} sm={9} md={6}>
            <Tree type="toppings" />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default TabToppings;
